import React, {Component} from 'react';
import Styles from './style.css';
import Header from "../../components/header/component";
import cx from "classnames";
import * as Icon from "react-feather";
import Footer from "../../components/footer/component";
import ContactForm from "../../components/contact-form/component";

class Campaign extends Component {

    constructor(props) {
        super(props);
        this.state = {};
    };

    componentWillMount() {}

    componentDidMount() {
        window.scrollTo(0, 0);
    }

    render() {
        return (
            <div className={Styles.app}>
                <Header view={"/campaign"} props={this.props}/>
                <ContactForm/>
                <Footer props={this.props}/>
            </div>
        );
    }
}

export default Campaign;


// WEBPACK FOOTER //
// ./src/pages/campaign/component.js